import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {AuthenticationService, CustomerService, StorageService} from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-portfoliorequest',
  templateUrl: './portfoliorequest.component.html',
  styleUrls: ['./portfoliorequest.component.css', 'style.css', 'boot-outline-btn.css']
})
export class PortfoliorequestComponent implements OnInit {
  type_of_entry = '-1';
  view = 'schedule';
  showActions = false;
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  loan_:any;
  creating_contract = false;
  customer: any;
  view_ = 'cheques';
  docpickups: any;
  showActionsModal = false;
  loading = false;
  where = '0';
  indebtedness = false;
  kyc_setup = '0';
  constructor(private DataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public router: Router,
              private authService: AuthenticationService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.DataService.changePortfolioView.subscribe(res => {
      this.view = res.view;

    });
     
  }
  viewLetterOfIndebtedness(){
    this.indebtedness = true;
  } 
  ngOnInit() {
    this.getSummary();
  }
  getSummary() { 
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();

    });

  }
  getLoan() {
    this.loan = this.loan_;
    this.where = '0';
    this.loading =true;
    this.view = 'statement';
    this.loansService.getLoanPortfolio(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.where = '2';
        this.loading = false;
        this.loan = data.loan;
        this.view = 'schedule';
      });
  }
  getCusomer(people_id) {
    this.loansService.getLoanContractCustomer(this.currentUser.token, people_id)
      .subscribe(data => {
        this.customer = data.data;
      });
  }
 
  registerPayment() {
    // this.dataService.onOpenApplicationsModal.emit({ section: 'register_payment', request_id: this.parentRouteId, loan: this.loan });
    this.DataService.onStartNewRepaymentFlow.emit({parentRouteId:this.parentRouteId});
  }
  grantRight(right) {
    return this.authService.userHasRights(right);
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.loan.loan.request_id, loan: this.loan.loan });
  }
  openModal_(section) {
    if (section === 'setup_cheques') {
      if (!this.grantRight('27')) {
        section = 'no_right';
      }
    }
    if (section === 'setup_cards') {
      if (!this.grantRight('35')) {
        section = 'no_right';
      }
    }
    if (section === 'account_debit') {
      if (!this.grantRight('35')) {
        section = 'no_right';
      }
    }
    if (section === 'remita_inflight') {
      if (!this.grantRight('81')) {
        section = 'no_right';
      }
    }
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId, loan: this.loan });
  }
  makePayment(event) { 
    this.DataService.onMakePaymentFromStatement.emit({parentRouteId:this.parentRouteId});
  }
  openCustomerReportedPayments(request_id){
    this.DataService.doOpenCustomerReportedPayments.emit({parentRouteId:request_id});
  }
  takeOwnership(customer) {
    //this.action = '1';
    //this.ownershipCustomer = customer;
    //this.owningStaff = this.currentUser;
    this.DataService.onTakeOwnership.emit(customer);

  }
  changeOwnership(customer) {
    //this.ownershipCustomer = customer;
   // this.owningStaff = this.currentUser;
    this.DataService.onchangeOwnership.emit(customer);
  }
  creditStatement() {
    if (!this.grantRight('59')) {
      this.DataService.onOpenLoanChildModal.emit({ 'location': 'no_right', data: this.loan });
    }
    this.DataService.onCreditLoanStatement.emit({ loan: this.loan, ttype: 2 });
  }
  debitStatement() {
    if (!this.grantRight('60')) {
      this.DataService.onOpenLoanChildModal.emit({ 'location': 'no_right', data: this.loan });
    }
    this.DataService.onCreditLoanStatement.emit({ loan: this.loan, ttype: 1 });
  }
  makeLoanPayment() {

    this.DataService.onMakePaymentFromStatement.emit(this.parentRouteId)
  }
  breakLoan() {
    this.DataService.onBreakingLoan.emit({request_id:this.parentRouteId,loan_viewed_details:{}})
  }
  initiateRollback(trans) {
    this.DataService.onRollbackPaymentFromStatement.emit({ 'location': 'initiate_roll_back', data: { loan: this.loan, trans: trans } });
  }
  stopAutoDebit() {
    if (!this.grantRight('59')) {
      this.DataService.onOpenLoanChildModal.emit({ 'location': 'no_right', data: this.loan });
    }
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'stop_auto_debit', data: this.loan });
  }
  startAutoDebit() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'start_auto_debit', data: this.loan });
  }
  sendAccountStatement() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_account_statement', data: this.loan });
  }
  requestForCard() {
    if (!this.grantRight('39')) {
      this.DataService.onOpenLoanChildModal.emit({ 'location': 'no_right', data: this.loan });
    }
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_new_card', data: this.loan });
  }
  sendEmailReminder() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_email_reminder', data: this.loan });
  }
  sendSMSReminder() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_sms_reminder', data: this.loan });
  }
 
  initiateStopRemitaCollection() {
    this.DataService.initStopRemita.emit({ loan: this.loan.loan });
  }
  initiateLoanBuyBack() {
    this.DataService.initLoanBuyBack.emit({ loan: this.loan.loan });
  }
   
  open_contract(request_id) {
    this.router.navigate(['../loan', request_id]);
  }
  break_loan() {
    this.DataService.onBreakLoan.emit();
  }
  changeDefaultRepayment() {
    this.DataService.onChangeDefaultPayment.emit({ loan: this.loan }); 
  }
  initiateSendRemitaLoanNotification() {
    this.DataService.remitaLoanNotification.emit({ loan: this.loan });
  }
  changePortfolioView(view){
    this.DataService.changePortfolioView.emit({ view: view });
  }
  makePay(){
    this.DataService.onStartNewRepaymentFlow.emit({parentRouteId:this.parentRouteId});
  }
  breakPay(){
    this.DataService.onBreakingLoan.emit(this.parentRouteId)
  }
  reviewToUp(){

  } 
  cancelToUp(request_id){
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'cancel_top_up_mod', data: request_id });
  } 
  
  reviewRollover(){
    
  } 
  cancelRollover(request_id){
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'cancel_roll_over_mod', data: request_id });
  } 
  acceptContract() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'accept_contract_mod', data: this.loan.loan });
  }
  requestFinancials() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_financial_mod', data: this.loan.loan });
  }
  requestOthers() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_others_mod', data: this.loan.loan });
  }
  requestGuarantors() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_guarantor_mod', data: this.loan.loan });
  }
  requestToGetPaid() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_to_get_paid', data: this.loan.loan });
  }

  requestKYC() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_kyc_mod', data: this.loan.loan });
  }

  requestDocs() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_docs_mod', data: this.loan.loan, docpickups: this.docpickups });
  }

  deleteRequest() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'delete_request_mod', data: this.loan.loan });
  }
  sendBVN() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_bvn_mod', data: this.loan.loan });
  }

  requestCard() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'request_card_mod', data: this.loan.loan });
  }

  sendContract() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'send_contract_mod', data: this.loan.loan });
  }

  confirmAccount() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'confirm_account_mod', data: this.loan.loan });
  }

  setupdirectdebit() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'setup_debit_mandate', data: this.loan.loan });
  }
  checkdirectdebitstatus() {
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'check_debit_mandate', data: this.loan.loan });
  }
  assignLoanOfficer() {
    this.DataService.onChangeLoanOfficer.emit({ loan: this.loan.loan });
  }
  openActionsForRolloverRequest(event){
    this.DataService.openRollOverActionModal.emit({ loan: this.loan.loan, actions_panel: 'rollover', request_id: event.request_id });
  }
  openActionsForPortfolioRequest(request_id){
    this.DataService.openRollOverActionModal.emit({ loan: this.loan, actions_panel: 'portfolio',request_id: request_id  });
  }
  setDefaultRepaymentMode(loan, repayment_mode) {
    if (!this.grantRight('54')) {
      this.DataService.onOpenLoanChildModal.emit({ 'location': 'no_right', data: this.loan });
    }
    this.DataService.onOpenLoanChildModal.emit({ 'location': 'set_default_repayment_mode', data: this.loan, repayment_mode: repayment_mode });
  }
}
